/**
 * Modes that define which products a reseller can consume through its API key.
 *  - ALL: every active product.
 *  - SELECTED: only the products listed in `productAccess.productIds` (product uuids).
 * @type {Object}
 */
export const PRODUCT_ACCESS_MODES = Object.freeze({
  ALL: "ALL",
  SELECTED: "SELECTED"
});
